export function getBoletim() {
  return {
    type: '@boletim/REQUEST_BOLETIM',
  };
}

export function getBoletimSuccess(boletim) {
  return {
    type: '@boletim/REQUEST_BOLETIM_SUCCESS',
    payload: boletim,
  };
}

export function getBoletimFailure() {
  return {
    type: '@boletim/REQUEST_BOLETIM_FAILURE',
  };
}
